import { gql } from '@apollo/client';

export const APPROVE_CUSTOMER_ART_PROOF = gql`
  mutation ApproveCustomerArtProof($campaignArtFileId: Int!) {
    approveCustomerArtProof(campaignArtFileId: $campaignArtFileId) {
      id
      artProofStatusId
      artProofStatus {
        id
        statusName
      }
      lastUpdated
    }
  }
`;

export const REJECT_CUSTOMER_ART_PROOF = gql`
  mutation RejectCustomerArtProof($campaignArtFileId: Int!, $reason: String!) {
    rejectCustomerArtProof(campaignArtFileId: $campaignArtFileId, reason: $reason) {
      id
      artProofStatusId
      artProofStatus {
        id
        statusName
      }
      lastUpdated
    }
  }
`;

